import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";

const inputCls = "mt-1 bg-[#F7F5F0] border-[#DCD8D0]";

export default function BookingSettings() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/admin/booking-settings").then(({ data }) => setS(data)).catch((e) => toast.error(formatError(e))); }, []);
  const set = (k) => (e) => setS((d) => ({ ...d, [k]: e.target.value }));
  const setPromo = (k) => (e) => setS((d) => ({ ...d, promo: { ...d.promo, [k]: e?.target ? e.target.value : e } }));
  const save = async () => {
    setSaving(true);
    try {
      const payload = { ...s, min_lead_days: Number(s.min_lead_days), default_min_nights: Number(s.default_min_nights),
        hold_minutes: Number(s.hold_minutes), max_nights: Number(s.max_nights), max_lead_days: Number(s.max_lead_days), promo: { ...s.promo, discount_pct: Number(s.promo.discount_pct) } };
      setS((await api.put("/admin/booking-settings", payload)).data);
      toast.success("Ajustes guardados");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setSaving(false);
    }
  };
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return (
    <div className="min-h-screen bg-[#F7F5F0]">
      <header className="bg-white border-b border-[#DCD8D0]">
        <div className="container-x py-4"><Link to="/admin" className="inline-flex items-center text-[#5C5C5C] hover:text-marca"><ArrowLeft className="h-4 w-4 mr-2" /> Panel</Link></div>
      </header>
      <main className="container-x py-8 max-w-3xl space-y-6">
        <h1 className="font-display text-3xl font-bold tracking-tight text-[#1A1A1A]">Reserva online</h1>
        {s && (
          <>
            <section className="bg-white border border-[#DCD8D0] rounded-xl p-6 grid sm:grid-cols-3 gap-4" data-testid="bs-rules">
              <div><Label>Antelación mínima (días)</Label><Input type="number" className={inputCls} value={s.min_lead_days} onChange={set("min_lead_days")} data-testid="bs-lead" /></div>
              <div><Label>Mínimo de noches</Label><Input type="number" className={inputCls} value={s.default_min_nights} onChange={set("default_min_nights")} /></div>
              <div><Label>Minutos para pagar</Label><Input type="number" className={inputCls} value={s.hold_minutes} onChange={set("hold_minutes")} data-testid="bs-hold" /></div>
              <div><Label>Máximo de noches online</Label><Input type="number" className={inputCls} value={s.max_nights} onChange={set("max_nights")} data-testid="bs-max-nights" /></div>
              <div><Label>Antelación máxima (días)</Label><Input type="number" className={inputCls} value={s.max_lead_days} onChange={set("max_lead_days")} data-testid="bs-max-lead" /></div>
              <div><Label>Hora de recogida</Label><Input type="time" className={inputCls} value={s.pickup_time} onChange={set("pickup_time")} /></div>
              <div><Label>Hora de devolución</Label><Input type="time" className={inputCls} value={s.return_time} onChange={set("return_time")} /></div>
            </section>
            <section className="bg-white border border-[#DCD8D0] rounded-xl p-6 grid sm:grid-cols-2 gap-4" data-testid="bs-promo">
              <label className="sm:col-span-2 flex items-center gap-2 text-sm"><Checkbox checked={!!s.promo.enabled} onCheckedChange={(v) => setPromo("enabled")(Boolean(v))} /> Promoción activa</label>
              <div><Label>Código</Label><Input className={inputCls} value={s.promo.code} onChange={setPromo("code")} data-testid="bs-promo-code" /></div>
              <div><Label>Descuento sobre las noches (%)</Label><Input type="number" className={inputCls} value={s.promo.discount_pct} onChange={setPromo("discount_pct")} /></div>
              <div><Label>Válida desde (día de la reserva)</Label><Input type="date" className={inputCls} value={s.promo.valid_from} onChange={setPromo("valid_from")} /></div>
              <div><Label>Válida hasta (reserva y salida)</Label><Input type="date" className={inputCls} value={s.promo.valid_until} onChange={setPromo("valid_until")} /></div>
            </section>
            <section className="bg-white border border-[#DCD8D0] rounded-xl p-6 text-sm text-[#5C5C5C] space-y-2">
              <div>Página de reservas: <a className="underline" href={`${origin}/reservar`}>{origin}/reservar</a></div>
              <div>Widget para tu web:</div>
              <pre className="bg-[#F7F5F0] p-3 rounded text-xs overflow-x-auto">{`<script src="${origin}/widget.js" data-lang="es" async></script>`}</pre>
            </section>
            <Button onClick={save} disabled={saving} className="bg-marca hover:bg-marca-hover text-white" data-testid="bs-save">{saving ? "Guardando…" : "Guardar"}</Button>
          </>
        )}
      </main>
    </div>
  );
}
